import { termsData } from "@/data/terms-data";
import { motion } from "framer-motion";
import { ShieldCheck, X } from "lucide-react";

export default function TernsAuth({
  isRtl,
  setIsTermsOpen,
  setTermsAccepted,
}: any) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-100 flex items-center justify-center p-4 sm:p-6 bg-slate-900/60 backdrop-blur-sm"
      dir={isRtl ? "rtl" : "ltr"}
    >
      <motion.div
        initial={{ scale: 0.95, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.95, opacity: 0, y: 20 }}
        transition={{ type: "spring", stiffness: 300, damping: 25 }}
        className="bg-white rounded-4xl shadow-2xl w-full max-w-4xl max-h-[85vh] flex flex-col overflow-hidden border border-slate-100"
      >
        {/* Modal Header */}
        <div className="flex items-center justify-between px-8 py-6 border-b border-slate-100 bg-white z-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-2xl bg-main/10 text-main flex items-center justify-center">
              <ShieldCheck size={20} />
            </div>
            <h3 className="text-xl font-black text-slate-900">
              {isRtl ? "الإقرار والموافقة الإلكترونية" : "Electronic Declaration & Consent"}
            </h3>
          </div>
          <button
            onClick={() => setIsTermsOpen(false)}
            className="p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-all"
          >
            <X size={24} />
          </button>
        </div>

        {/* Modal Content — Section 10 only: Electronic Declaration and Consent */}
        <div className="px-8 py-6 overflow-y-auto flex-1 space-y-6 custom-scrollbar text-start bg-slate-50/50">
          {(() => {
            const allSections = isRtl ? termsData.ar : termsData.en;
            const section = allSections[allSections.length - 1];
            return (
              <div className="space-y-4">
                <div className="space-y-3">
                  {section.content?.map((item: string, i: number) => {
                    const isHeading = item.endsWith(":");
                    return isHeading ? (
                      <p key={i} className="text-slate-900 font-black text-sm mt-5 first:mt-0">
                        {item}
                      </p>
                    ) : (
                      <p key={i} className="text-slate-600 text-sm md:text-base leading-relaxed ps-4 border-s-2 border-slate-100">
                        {item}
                      </p>
                    );
                  })}
                </div>
              </div>
            );
          })()}
        </div>

        {/* Modal Footer */}
        <div className="px-8 py-6 border-t border-slate-100 bg-white flex flex-col sm:flex-row justify-between items-center gap-4 shrink-0">
          <p className="text-sm font-bold text-slate-400">
            {isRtl
              ? "يرجى قراءة الشروط جيداً قبل الموافقة."
              : "Please read the terms carefully before agreeing."}
          </p>
          <div className="flex gap-3 w-full sm:w-auto">
            <button
              onClick={() => setIsTermsOpen(false)}
              className="flex-1 sm:flex-none px-6 py-4 bg-slate-100 text-slate-600 font-bold rounded-2xl hover:bg-slate-200 transition-colors"
            >
              {isRtl ? "إلغاء" : "Cancel"}
            </button>
            <button
              onClick={() => {
                setTermsAccepted(true);
                setIsTermsOpen(false);
              }}
              className="flex-1 sm:flex-none px-8 py-4 bg-slate-900 text-white font-bold rounded-2xl hover:bg-main hover:shadow-lg hover:shadow-main/20 transition-all flex items-center justify-center gap-2"
            >
              <ShieldCheck size={18} />
              {isRtl ? "أوافق ومتابعة" : "Agree & Continue"}
            </button>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}
